<!-- 业务商品列表 -->
<template>
    <div class='page_content'>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @getPageInfo="getPageInfo" @actionSet="actionSet" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <v-search v-if="pageShowData.jurHead" :flagList="['priceType']" :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch">
                    <template slot="searchInput" slot-scope="{formOneValue}">
                        <el-select v-if="formOneValue.entityField == 'priceType'" clearable v-model="getRequestData[formOneValue.entityField]">
                            <el-option v-for="item in priceOption" :key="item.levleId" :label="item.levleName" :value="item.levleId">
                            </el-option>
                        </el-select>
                    </template>
                </v-search>
            </div>
        </div>
        <div class="page_content_center">
            <el-table v-if="pageShowData.jurTableVo" :key="tableFlag" stripe @selection-change="handleSelectionChange" :data="returnData.list" :height="tableHeight" border style="width: 100%" highlight-current-row size="mini">
                <!-- 主信息 -->
                <el-table-column type="selection" width="40"></el-table-column>
                <template v-for="(tableValye, tableKey) in tableList">
                    <el-table-column v-if="tableValye.isShow == 1" :key="tableKey" align="center" :prop="tableValye.entityField" :label="tableValye.showField" show-overflow-tooltip :min-width="tableValye.fieldWeight"
                        :fixed="!tableValye.fieldShow">
                        <template slot-scope="scope">
                            <span v-if="tableValye.fieldType == 'date'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </span>
                            <span v-else-if="tableValye.isRift == 1">
                                <a @click="toDetail(scope.row[tableValye.riftField])">{{
                                        scope.row[tableValye.entityField] }}</a>
                            </span>
                            <el-input @mousewheel.native.prevent clearable style="width: 90px;margin: 0 1px;" @blur="blur(scope.$index, tableValye.entityField)" v-else-if="tableValye.fieldType == 'input'" type="number"
                                v-model="scope.row[tableValye.entityField]"></el-input>
                            <span v-else>
                                {{ scope.row[tableValye.entityField] }}
                            </span>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName"></SearchScheme>
        </el-dialog>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>

    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import nameList from "./batchPriceMaintain.js";
import SearchScheme from "../../byComponents/SearchScheme.vue";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: { SearchScheme },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            tableFlag: 0,
            getRequestData: {},
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            buttonList: [],
            pageShowData: {},
            tableList: [],
            selectData: [],
            parentSearchData: {},
            seId: "",
            sField: "",
            DialogVisible: false,
            seWidth: "",
            seTitle: "",
            dictionariesDatas: "",
            priceOption: []
        };
    },
    //监听属性 类似于data概念
    //方法集合
    methods: {
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path)
            let responseData = await this.$http.getJur({ ids: [pathId.jurId] })
            if (responseData.status == 200) {
                this.pageShowData = responseData.result
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 50)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 50)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.tableList = JSON.parse(JSON.stringify(this.pageShowData.jurTableVo.jurconfigtable))
                this.getButtonList()
                this.getHead()
                this.getDataList()
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        clear(val) {
            if (val) {
                var arr = val.split(",")
                arr.forEach(item => {
                    this.$set(this.getRequestData, item, "")
                })
            }
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, type, sField) {
            this.DialogVisible = true;
            this.seId = sId;
            this.sField = sField;
            this.parentSearchData[type] = this.getRequestData[type];
        },
        // 赋值字段
        paramValue(val) {
            console.log(this.sField);
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.getRequestData[item] = val[item];
            });
        },
        //检索带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val);
            }
        },
        blur(index, index1) {
            console.log(this.returnData.list[index][index1]);
            var num = String(this.returnData.list[index][index1])
            if (num.indexOf(".") != -1 && num.split('.')[1].length >= 10) {
                this.returnData.list[index][index1] = this.$common.getDecimalInfo(2, this.returnData.list[index][index1])
            }

        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({ //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    } //参数
                }, '*');
            }
        },
        async actionSet(actionData) {
            switch (actionData.actionType) {
                case 4:
                    if (this.selectData.length == 0) {
                        return this.$message.error("请选择数据")
                    }
                    this.save()
                    break;
                case 5:
                    if (this.selectData.length == 0) {
                        return this.$message.error("请选择数据")
                    }
                    this.$confirm("确定删除该数据?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                        .then(() => {
                            this.deleteInfo()
                        })
                        .catch(() => { });

                    break;
                case 6:
                    this.getRequestData.page = 1;
                    await this.getDataList();
                    if (this.returnData.list.length == 0) return this.$message.warning("暂无导出数据")
                    this.getRequestData.start = this.getRequestData.start?this.getRequestData.start:""
                    this.getRequestData.end = this.getRequestData.end?this.getRequestData.end:""
                    window.location.href = this.$store.getters.getConfig.requestUrl + `/batchPrice/exportLotPrice` + this.$common.getUrl({ ...this.getRequestData, ormId: sessionStorage.getItem("ormId") })
                    break;
                default:
                    break;
            }
        },
        //删除
        async deleteInfo() {
            let ids = []
            this.selectData.forEach(item => {
                ids.push(item.bgsId)
            })
            let res = await this.$http.batchPriceDeleteLotPrice({ ids: ids })
            if (res.status == 200) {
                this.$message.success(res.message)
                this.getDataList()
            } else {
                this.$message.error(res.message)
            }
        },
        //保存
        async save() {
            var arr = []
            console.log(this.selectData)
            this.selectData.forEach(item => {
                arr.push(
                    {
                        "bgsId": item.bgsId,
                        "lowestPrice": item.lowestPrice,
                        "priceList": [
                        ]
                    }
                )
            })
            console.log(arr)
            this.selectData.forEach((item, index) => {
                for (const key in item) {
                    if (key.indexOf('levlePrice') != -1) {
                        arr[index].priceList.push({
                            levleId: Number(key.split("_")[1]),
                            levlePrice: item[key] === '' ? 0 : this.$common.getDecimalInfo(2, item[key]),
                            levleName: key.split("_")[2],
                        })
                    }
                }

                item.priceList.forEach((item1, index1) => {
                    arr[index].priceList[index1] ? this.$set(arr[index].priceList[index1], "oldPrice", item1.levlePrice) : ''
                })
            })
            const responseData = await this.$http.batchPriceUpdateLotPrice(arr)
            console.log(responseData);
            if (responseData.status == 200) {
                this.$message.success("操作成功")
                this.getDataList()
            } else {
                this.$message.error(responseData.message)
            }
        },
        handleSelectionChange(val) {
            this.selectData = val
            console.log(this.selectData);
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.batchPriceQueryLotPrice(this.getRequestData);
            if (responseData.status == 200) {
                console.log(responseData);
                var list = responseData.result.list;
                if (list.length > 0) {
                    list.forEach((item) => {
                        if (item.priceList.length > 0) {
                            item.priceList.forEach(item1 => {
                                this.$set(item, 'levlePrice_' + item1.levleId + "_" + item1.levleName, item1.levlePrice === '' ? 0 : item1.levlePrice)
                            })
                            item.lowestPrice = item.priceList[0].lowestPrice
                        }
                    })
                }
                this.returnData.list = list
                this.returnData.pages = responseData.result.pages;
                this.returnData.total = responseData.result.total;
                this.returnData.pageNum = responseData.result.pageNum;
                this.$nextTick(() => {
                    this.tableHeight = this.$common.getTableHeight()
                    this.tableFlag++
                })
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        async getHead() {

            let res = await this.$http.batchPriceQueryPriceLevensList()
            console.log(res)
            if (res.status == 200) {
                this.priceOption = res.result
                res.result.forEach(item => {
                    this.tableList.push({
                        entityField: 'levlePrice_' + item.levleId + "_" + item.levleName,
                        showField: item.levleName,
                        fieldWeight: this.calWidth(item.levleName),
                        fieldType: "input",
                        isShow: 1,
                        fieldShow: true
                    })
                })
            }
        },
        calWidth(name) {
            return 120
        },
        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
        },

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo()
        var obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
        for (const key in obj) {
            this.$set(this.getRequestData, key, obj[key])
        }

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.$nextTick(() => {
            this.tableHeight = this.$common.getTableHeight()
            this.tableFlag++
        })
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.tableHeight = this.$common.getTableHeight()
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped></style>